export const GET_FEEDS = "GET_FEEDS";
export const SET_FEEDS = "SET_FEEDS";
